import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  detailsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    '@media (max-width: 640px)': {
      width: 'auto',
      margin: '24px 0px 0px 16px',
    },
  },
  detailsHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  detailsContent: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '16px',
  },
  detailsContentContainer: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: '18px',
  },
  detailsHeaderTitleText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '30px',
  },
  detailsHeaderContentText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
  detailsContentTitleText: {
    color: theme.evPalette.charcoal[600],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    minWidth: '30%',
    '@media (min-width: 640px)': {
      width: '120px',
      minWidth: '0%',
    },
  },
  message: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
  },
  chipElement: {
    height: '20px',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: '10px',
    margin: '2px',
    maxWidth: '100%',
    '@media (min-width: 640px)': {
      maxWidth: '180px',
    },
  },
}));
